import React from 'react';
import {getOrdersReady, getOrdersReadyPage, getOrderByCode} from "../../utilityFunctions/WarehouseUtil";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {Typography} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Dialog from '@mui/material/Dialog';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Colors from "../../components/ui/Colors";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useHistory} from "react-router-dom";
import Paper from '@mui/material/Paper';

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    // weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

let orders;
let allOrders;

const pageRequest = {
    page: "",
};

const pageSize=100;

export default function PendingOrders(props) {
    const {loginUser} = props;

    const history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const[disableNextButton, setDisableNextButton] = React.useState(false);

    React.useEffect(()=> {
        orders = null;
        allOrders=null;
        initialValues();
    }, []);

    const initialValues = async () => {

        pageRequest.page= 0;
        
        setLoading(true);
        const receivedOrders = await getOrdersReadyPage(pageRequest, loginUser.jwtToken);
        setLoading(false);

        if(!receivedOrders){
            return;
        }

        if(receivedOrders.length < pageSize){
            setDisableNextButton(true);
        }else{
            setDisableNextButton(false);
        }

        //TODO: Conduct this filtering in the back. Done
        // orders = receivedOrders.filter((el) => el.status === "pending");
        orders = receivedOrders;

        renderReadyOrders();

        return orders;
    };

    const [readyOrders, setReadyOrders] = React.useState(null);

    const [selectedOrder, setSelectedOrder] = React.useState([]);

    const [currentPage, setCurrentPage] = React.useState(1);

    // --- Filter & sort state (declared early so effects and render fn can close over them) ---
    const [clientFilter, setClientFilter] = React.useState("");
    const [dateFrom, setDateFrom] = React.useState("");
    const [dateTo, setDateTo] = React.useState("");
    const [sortField, setSortField] = React.useState(null); // "date" | "orderAmount"
    const [sortDir, setSortDir] = React.useState("asc");
    const [selectedOrderCode, setSelectedOrderCode] = React.useState("");

    const handlePageChange = async (newPage) => {
        setCurrentPage(newPage);
        pageRequest.page= newPage-1;

        setLoading(true);
        const receivedOrders = await getOrdersReadyPage(pageRequest, loginUser.jwtToken);
        setLoading(false);

        if(!receivedOrders){
            return;
        }

        if(receivedOrders.length < pageSize){
            setDisableNextButton(true);
        }else{
            setDisableNextButton(false);
        }

        // orders = receivedOrders.filter((el) => el.status === "pending");
        orders = receivedOrders;

        renderReadyOrders();
    };

    // Function to handle order checkbox change
    const orderChecked = (order) => {
        // Toggle the checked state of the order
        const isChecked = selectedOrder.includes(order);
        if (isChecked) {
            // If already selected, unselect the order
            // setSelectedOrder(selectedOrder.filter((orderEl) => orderEl.orderCode !== order.orderCode));
            setSelectedOrder(selectedOrder.filter((orderEl) => orderEl.id !== order.id));
            
        } else {
            // If not selected, select the order
            
            const sameOrders = orders.filter((el) => el.orderCode === order.orderCode);
            setSelectedOrder([...selectedOrder, ...sameOrders]);

            // setSelectedOrder([...selectedOrder, order]);
        }
    };

    React.useEffect(()=> {
        renderReadyOrders();
    }, [selectedOrder]);

    // Re-render list whenever any filter or sort state changes
    React.useEffect(()=> {
        renderReadyOrders();
    }, [clientFilter, dateFrom, dateTo, sortField, sortDir, selectedOrderCode]);

    const renderReadyOrders = async (overrideClientFilter, overrideDateFrom, overrideDateTo, overrideSortField, overrideSortDir) => {
        const ordersArray = orders;

        if(!ordersArray){
            return;
        }

        const uniqueOrdersSet = new Set();

        if(selectedOrder && !allOrders){
            selectedOrder.forEach((order) => uniqueOrdersSet.add(order));
        }


        ordersArray.forEach((order) => uniqueOrdersSet.add(order));

        // Convert the set back to an array
        let uniqueOrdersArray = [...uniqueOrdersSet];

        if(selectedOrder && uniqueOrdersSet){
            uniqueOrdersArray.sort(sortOrders);
        }

        else{
            uniqueOrdersArray.sort((a, b) => b.orderCode - a.orderCode);
        }

        // Apply client-side filters. Use override values when called synchronously
        // right after a state setter (state updates are async), otherwise fall back
        // to the current state values captured in the closure.
        const activeClientFilter = overrideClientFilter !== undefined ? overrideClientFilter : clientFilter;
        const activeDateFrom     = overrideDateFrom     !== undefined ? overrideDateFrom     : dateFrom;
        const activeDateTo       = overrideDateTo       !== undefined ? overrideDateTo       : dateTo;
        const activeSortField    = overrideSortField    !== undefined ? overrideSortField    : sortField;
        const activeSortDir      = overrideSortDir      !== undefined ? overrideSortDir      : sortDir;

        if (activeClientFilter.trim()) {
            const lower = activeClientFilter.trim().toLowerCase();
            uniqueOrdersArray = uniqueOrdersArray.filter((o) =>
                o.clientName && o.clientName.toLowerCase().includes(lower)
            );
        }

        if (selectedOrderCode && selectedOrderCode.trim()) {
            const codeFilter = selectedOrderCode.trim().toLowerCase();
            uniqueOrdersArray = uniqueOrdersArray.filter((o) =>
                o.orderCode && String(o.orderCode).toLowerCase().includes(codeFilter)
            );
        }

        if (activeDateFrom) {
            const from = new Date(activeDateFrom + 'T00:00:00');
            uniqueOrdersArray = uniqueOrdersArray.filter((o) => new Date(o.date) >= from);
        }

        if (activeDateTo) {
            const to = new Date(activeDateTo + 'T23:59:59.999');
            uniqueOrdersArray = uniqueOrdersArray.filter((o) => new Date(o.date) <= to);
        }

        if (activeSortField) {
            uniqueOrdersArray.sort((a, b) => {
                let valA, valB;
                if (activeSortField === "date") {
                    valA = new Date(a.date).getTime();
                    valB = new Date(b.date).getTime();
                } else {
                    valA = a.orderAmount || 0;
                    valB = b.orderAmount || 0;
                }
                return activeSortDir === "asc" ? valA - valB : valB - valA;
            });
        }

        setReadyOrders(
            <List sx={{width: "100%", marginTop: {xs: "3rem", sm: "2rem", md: "2rm"}}}>
                {uniqueOrdersArray.map((order)=> {
                    const isChecked = selectedOrder.includes(order);
                    return(
                        <ListItem key={generateRandomKey()} disablePadding divider sx={{marginBottom: "1.5rem"}}>
                            <ListItemButton key={generateRandomKey()} onClick={() => orderChecked(order)}>
                                <Grid key={generateRandomKey()}  container spacing={1}>
                                    <Grid item xs={2} sm={2} md={2} style={{textAlign: "center"}}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox color="secondary" name="order" value="yes"
                                                    checked={isChecked}
                                                    onChange={() => orderChecked(order)}
                                                />

                                            }
                                        />
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{`${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(order.date))}`}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{order.orderCode}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{order.clientName}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{order.description}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{new Intl.NumberFormat('es-CO').format(order.orderAmount)}</Typography>
                                    </Grid>
                                </Grid>
                            </ListItemButton>
                        </ListItem>
                    )
                })

                }
            </List>
        );
    };

    const sortOrders = (a, b) => {
        // First, sort by 'checkpoint' (selected comes first)
        const isCheckedA = selectedOrder.includes(a);
        const isCheckedB = selectedOrder.includes(b);
    
        if (isCheckedA && !isCheckedB) {
          return -1; // a comes first
        } else if (!isCheckedA && isCheckedB) {
          return 1; // b comes first
        }
    
        // If 'checkpoint' is the same or both are selected/unselected, then sort by 'orderCode'
        return b.orderCode - a.orderCode;
    };


    const [actionsBox, setActionsBox] = React.useState(false);
    
    const closeActionBox = () => {
        setActionsBox(false);
    }

    const goToUpdate = () => {
        history.push({
            pathname: "/warehouse/update-orders",
            state: {
                order: selectedOrder,
            }
        });
    };

    const toggleSort = (field) => {
        if (sortField === field) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDir("asc");
        }
    };

    const sortIndicator = (field) => {
        if (sortField !== field) return "";
        return sortDir === "asc" ? " ▲" : " ▼";
    };

    // Selection summary derived from selectedOrder
    const selectionSummary = React.useMemo(() => {
        if (!selectedOrder || selectedOrder.length === 0) return null;
        const count = selectedOrder.length;
        const clients = new Set(selectedOrder.map((o) => o.clientName)).size;
        const units = selectedOrder.reduce((acc, o) => acc + (o.orderAmount || 0), 0);
        return { count, clients, units };
    }, [selectedOrder]);

    const orderCodeChange = (e) => {
        setSelectedOrderCode(e.target.value);
    }

    const getFilteredOrder = async (e) => {

        const orderRequest = {
            orderCode: selectedOrderCode
        }

        setLoading(true);
        const orderRequested = await getOrderByCode(orderRequest, loginUser.jwtToken);
        setLoading(false);

        if(!orderRequested){
            return;
        };

        allOrders=orders;

        orders=orderRequested;

        renderReadyOrders();
    };

    const allPageOrders = () => {
        setSelectedOrderCode("");

        orders=allOrders;

        allOrders=null;

        renderReadyOrders();
    }

    const generateRandomKey = () => {
        const randomString = Math.random().toString(36).slice(2);
        const timestamp = Date.now().toString(36);
        return randomString + '_' + timestamp;
    };

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "center"},
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                    overflowY: "scroll",
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> : 
            <>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} sx={{marginTop: "2rem", textAlign: "center"}}>
                        <Typography variant="h6" sx={{fontWeight: "bold", color: Colors.primary}}>
                            Órdenes Pendientes
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Button onClick={goToUpdate} variant="contained" sx={{backgroundColor: Colors.primary, marginTop: "1rem",}}>
                            Despacho
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                                <TextField
                                    sx={{width: "20%"}}
                                    variant="standard"
                                    fullWidth={true}
                                    id="selectedOrderCode"
                                    name="selectedOrderCode"
                                    label={<Typography variant="body2">Código</Typography>}
                                    value={selectedOrderCode}
                                    onChange={(e)=> orderCodeChange(e)}
                                    autoComplete="off"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Client name filter + date range filters */}
                    <Grid item xs={12} sm={12} md={12} sx={{marginTop: "1rem"}}>
                        <Grid container spacing={1} justifyContent="center" alignItems="flex-end">
                            {/* Client filter */}
                            <Grid item xs={12} sm={4} md={3} sx={{display: "flex", alignItems: "flex-end", gap: "0.5rem"}}>
                                <TextField
                                    variant="standard"
                                    fullWidth
                                    label={<Typography variant="body2">Filtrar por cliente</Typography>}
                                    value={clientFilter}
                                    onChange={(e) => setClientFilter(e.target.value)}
                                    autoComplete="off"
                                />
                                {clientFilter && (
                                    <Button
                                        onClick={() => setClientFilter("")}
                                        size="small"
                                        variant="outlined"
                                        sx={{whiteSpace: "nowrap", minWidth: "auto", fontSize: "0.7rem"}}
                                    >
                                        Limpiar
                                    </Button>
                                )}
                            </Grid>
                            {/* Date from */}
                            <Grid item xs={6} sm={3} md={2}>
                                <TextField
                                    variant="standard"
                                    fullWidth
                                    type="date"
                                    label={<Typography variant="body2">Fecha desde</Typography>}
                                    value={dateFrom}
                                    onChange={(e) => setDateFrom(e.target.value)}
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            {/* Date to */}
                            <Grid item xs={6} sm={3} md={2}>
                                <TextField
                                    variant="standard"
                                    fullWidth
                                    type="date"
                                    label={<Typography variant="body2">Fecha hasta</Typography>}
                                    value={dateTo}
                                    onChange={(e) => setDateTo(e.target.value)}
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            {/* Clear date filters */}
                            {(dateFrom || dateTo) && (
                                <Grid item xs={12} sm={2} md={1} sx={{display: "flex", justifyContent: "center"}}>
                                    <Button
                                        onClick={() => { setDateFrom(""); setDateTo(""); }}
                                        size="small"
                                        variant="outlined"
                                        sx={{fontSize: "0.7rem"}}
                                    >
                                        Limpiar fechas
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>

                    {/* Selection summary bar */}
                    {selectionSummary && (
                        <Grid item xs={12} sm={12} md={12} sx={{marginTop: "1rem"}}>
                            <Paper
                                elevation={2}
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 10,
                                    padding: "0.5rem 1rem",
                                    backgroundColor: Colors.primary,
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Typography variant="body2" sx={{color: "white", fontWeight: "bold"}}>
                                    {`${selectionSummary.count} órdenes seleccionadas | ${selectionSummary.clients} clientes | ${new Intl.NumberFormat('es-CO').format(selectionSummary.units)} unidades totales`}
                                </Typography>
                            </Paper>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={12}>
                        <Grid container sx={{marginTop: "1.5rem"}}>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>

                            </Grid>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography
                                    variant="body1"
                                    onClick={() => toggleSort("date")}
                                    sx={{color: "black", fontWeight: "bold", textDecoration: 'underline', cursor: "pointer", userSelect: "none"}}
                                >
                                    Fecha{sortIndicator("date")}
                                </Typography>
                            </Grid>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Código</Typography>
                            </Grid>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Cliente</Typography>
                            </Grid>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Producto</Typography>
                            </Grid>
                            <Grid  item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography
                                    variant="body1"
                                    onClick={() => toggleSort("orderAmount")}
                                    sx={{color: "black", fontWeight: "bold", textDecoration: 'underline', cursor: "pointer", userSelect: "none"}}
                                >
                                    Cantidad{sortIndicator("orderAmount")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        {readyOrders}
                    </Grid>

                        
                    {!selectedOrderCode &&
                        <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginTop: "2rem", marginBottom: "2rem" }}>
                            <Button
                                onClick={() => handlePageChange(currentPage - 1)}
                                variant="contained"
                                disabled={currentPage === 1}
                                sx={{ marginRight: "1rem" }}
                            >
                                Anterior
                            </Button>
                            <Typography>{currentPage}</Typography>
                            <Button
                                onClick={() => handlePageChange(currentPage + 1)}
                                variant="contained"
                                disabled={disableNextButton}
                                sx={{ marginLeft: "1rem" }}
                            >
                                Siguiente
                            </Button>
                        </Grid>
                    }
                </Grid>

             

                <Dialog open={actionsBox} onClose={closeActionBox}
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: {xs: "80%", sm: "40%", md: "30%"},
                                height: "20%"
                            },
                        },
                    }}
                >
                    <List sx={{width: "100%",}}>
                        <ListItem disablePadding divider sx={{marginBottom: "1.5rem"}}>
                            <ListItemButton  onClick={goToUpdate}>
                                <Typography variant="h6">Completar Orden</Typography>
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Dialog>
            </>
            }
            </Box>
        </Box>
    )
}

